import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "itemcard" }

import ContactForm from '@/components/help/ContactForm.vue';
import PageHead from '@/components/shared/PageHead.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const head = {
  title: 'Contact ProxyScrape',
  subtitle: "Contact us if the FAQ doesn't answer your question.",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PageHead, { head: head }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ContactForm)
          ])
        ])
      ])
    ])
  ]))
}
}

})